import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'jsonHighlight',
})
export class JsonHighlightPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: any): SafeHtml {
    if (!value) {
      return '';
    }

    const json = JSON.stringify(value, null, 2);

    const highlighted = json.replace(
      /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(:)?|\b(true|false|null)\b|\b[\d.]+\b)/g,
      (match) => {
        let cls = 'text-primary-400';
        if (/^"/.test(match)) {
          if (/:$/.test(match)) {
            cls = 'text-secondary-500';
          } else {
            cls = 'text-warning';
          }
        } else if (/true|false/.test(match)) {
          cls = 'error';
        } else if (/null/.test(match)) {
          cls = 'success';
        }
        return `<span class="${cls}">${match}</span>`;
      },
    );

    return this.sanitizer.bypassSecurityTrustHtml(highlighted);
  }
}
